import WindowLocation from './windowLocation'

class AmplifyLoginHelper {
  private static storageKey = 'amplify_redirect_path'

  // Call this before signInWithRedirect
  static handleLanding () {
    const currentPath = WindowLocation.pathname() + WindowLocation.search()
    localStorage.setItem(AmplifyLoginHelper.storageKey, currentPath)
  }

  // Call this after redirect, on app load
  static handleRedirect () {
    const returnTo = localStorage.getItem(AmplifyLoginHelper.storageKey)
    if (returnTo) {
      localStorage.removeItem(AmplifyLoginHelper.storageKey)
      WindowLocation.replace(returnTo)
    }
  }
}

export default AmplifyLoginHelper
